import { Collapse, Divider, Fade } from '@material-ui/core';
import { useHistory, useRouteMatch } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { alpha, useTheme } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import SendIcon from '@material-ui/icons/Send';
import UndoIcon from '@material-ui/icons/Undo';
import { useKeycloak } from '@react-keycloak/web';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import ConfirmationDialog from '../../../components/ConfirmationDialog';
import FinalButtons from '../../../FinalButtons';
import FinalButtonsMobile from '../../../FinalButtonsMobile';
import axios from '../../../utils/axios';
import ESTADOS_FORMULARIO from '../../../utils/constants';
import { mainDefault } from '../../../utils/data-utils';
import { loadEventos, loadFormulario } from '../../../utils/form-utils';
import FormDataView from './FormDataView';

const styles = theme => ({
  img: {
    width: '150px',
    [theme.breakpoints.down('sm')]: {
      width: '100px'
    }
  },
  container: {
    marginLeft: 0,
    marginRight: 0,
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  innerContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
      padding: theme.spacing(0),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(5)
    }
  },
  stepper: {
    [theme.breakpoints.up('md')]: {
      borderRadius: theme.spacing(0.5),
      background: alpha(theme.palette.primary.main, 0.05)
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  stepLabel: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  stepContainer: {
    // padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  inputGroup: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  sidebarAboutBox: {
    // marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    // marginLeft: theme.spacing(6),
    background: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)'
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  datosPrueba: {
    paddingBottom: theme.spacing(2)
  }
});

const forms = {
  INICIAL: 'INICIAL',
  PASOS: 'PASOS',
  FINAL: 'FINAL'
};

const FormularioView = props => {
  const history = useHistory();
  const {
    params: { id }
  } = useRouteMatch();
  const myRef = useRef(null);
  // const scrollTop = () => setTimeout(() => scrollToRef(myRef));
  const { classes, enqueueSnackbar } = props;
  const isDirty = false;
  const [baseObject, setBaseObject] = useState({
    ...mainDefault
  });
  const [eventos, setEventos] = useState([]);
  const activeStep = 0;
  const [enviado] = useState(false);
  const [loadingEdit] = useState(false);
  const [formPrepared] = useState(true);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [loadingSendPre, setLoadingSendPre] = useState(false);
  const [activeForm, setActiveForm] = useState(forms.PASOS);
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const formik = useRef();

  const { keycloak } = useKeycloak();

  console.log('keycloak', keycloak);
  const gruposList = keycloak.tokenParsed.groups || [];
  const esAdmision = gruposList.includes('GR_EXPORTAFACIL_ADMISION');

  const handleOk = () => {
    // setActiveStep(prevActiveStep => prevActiveStep + 1);
    setOpenConfirmation(true);
  };

  const handleBack = () => {
    history.push('/formularios');
  };

  const admitir = async values => {
    setLoadingSendPre(true);
    try {
      const valuesToSend = Object.assign({}, values);
      valuesToSend.idFormulario = id;
      valuesToSend.pesoTarifado = values.pesoTarifado;
      valuesToSend.totalFlete = values.totalFlete;
      valuesToSend.cantidadBultos = values.cantidadBultos;

      try {
        await axios.post('formularios/admitir', valuesToSend);
        enqueueSnackbar('Enviado correctamente', { variant: 'success' });
        history.push('/formularios');
      } catch (err) {
        console.log(err);
        enqueueSnackbar('Error al intentar enviar', { variant: 'error' });
      }

      setOpenConfirmation(false);
      // scrollTop();
      setLoadingSendPre(false);
    } catch (error) {
      console.log(error);
      setLoadingSendPre(false);
    }
  };

  useEffect(
    () => {
      const eventListener = event => {
        if (isDirty) {
          // Cancel the event as stated by the standard.
          event.preventDefault();
          // Chrome requires returnValue to be set.
          // eslint-disable-next-line no-param-reassign
          event.returnValue =
            'Es posible que los cambios que implementaste no se puedan guardar';
        }
      };
      window.addEventListener('beforeunload', eventListener);
      return function cleanup() {
        window.removeEventListener('beforeunload', eventListener);
      };
    },
    [activeStep, isDirty]
  );

  const loadFormularioAsync = async idFormulario => {
    const formulario = await loadFormulario(idFormulario);
    setBaseObject(prev => ({ ...prev, ...formulario }));
  };

  const loadEventosAsync = async idFormulario => {
    const eventosList = await loadEventos(idFormulario);
    setEventos(eventosList);
  };

  const puedeAdmitir =
    esAdmision && baseObject?.estadoActual === ESTADOS_FORMULARIO.PENDIENTE;

  const buttonProps = {
    okText: puedeAdmitir && 'Admitir formulario',
    cancelText: 'Volver',
    handleBack,
    isPhone,
    classes,
    loadingSendPre,
    handleOk: puedeAdmitir && handleOk
  };
  const Buttons = () =>
    isPhone ? (
      <FinalButtonsMobile {...buttonProps} />
    ) : (
      <FinalButtons {...buttonProps} />
    );

  useEffect(
    () => {
      loadFormularioAsync(id);
      loadEventosAsync(id);
    },
    [id]
  );

  return (
    <div>
      <div className={classes.container}>
        <Paper className={classes.paper} elevation={8}>
          <div ref={myRef} style={{ height: 16 }} />
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Fade
              in={loadingEdit}
              style={{
                transitionDelay: loadingEdit ? '800ms' : '0ms'
              }}
              unmountOnExit
            >
              <CircularProgress />
            </Fade>
          </div>
          {formPrepared && (
            <>
              <FormDataView
                baseObject={baseObject}
                eventos={eventos}
                isPhone={isPhone}
                {...{
                  activeStep,
                  isPhone,
                  classes,
                  loadingSendPre,
                  handleBack,
                  handleOk,
                  puedeAdmitir:
                    esAdmision &&
                    baseObject?.estadoActual === ESTADOS_FORMULARIO.PENDIENTE
                }}
              />
              <br />
              <Divider />
              <br />
              <Buttons />
            </>
          )}

          <Collapse in={activeForm === forms.FINAL} mountOnEnter unmountOnExit>
            <Container style={{ paddingTop: 30 }}>
              {formik.current && <div>Más datos</div>}
              {!enviado && (
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <Grid item>
                    <Button
                      onClick={() => setActiveForm(forms.PASOS)}
                      className={classes.backButton}
                      size={isPhone ? 'small' : 'medium'}
                      startIcon={<UndoIcon />}
                    >
                      Volver
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      onClick={() => setOpenConfirmation(true)}
                      className={classes.backButton}
                      size={isPhone ? 'small' : 'medium'}
                      variant="contained"
                      color="primary"
                      endIcon={<SendIcon />}
                    >
                      Enviar
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Container>
          </Collapse>
        </Paper>
        <ConfirmationDialog
          open={openConfirmation}
          onConfirm={admitir}
          onClose={() => setOpenConfirmation(false)}
        />
      </div>
    </div>
  );
};

FormularioView.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withSnackbar(withStyles(styles)(FormularioView));
